
    import {
        Component, Prop, Vue, PropSync,
    } from 'vue-property-decorator';
    import {
        VDivider,
        VList,
        VListGroup,
        VListItem,
        VListItemAvatar,
        VListItemContent,
        VListItemSubtitle,
        VListItemTitle,
        VNavigationDrawer,
    } from 'vuetify/lib';
    import { TuningNavList } from '../../tunings/types';

    @Component({
        components: {
            VDivider,
            VList,
            VListGroup,
            VListItem,
            VListItemAvatar,
            VListItemContent,
            VListItemSubtitle,
            VListItemTitle,
            VNavigationDrawer,
        },
    })
    export default class Navbar extends Vue {
        @Prop({ required: true })
        readonly items!: TuningNavList;

        @PropSync('activeNav', { required: true })
        activeNavId!: string;

        @PropSync('openNav', { required: true })
        openMobile!: boolean;

        isActive(id: string): string {
            return id === this.activeNavId ? 'v-list-item--active' : '';
        }

        selectNav(id: string) {
            this.openMobile = false;
            this.activeNavId = id;
        }
    }
